webpackJsonp([149108190732818],{

/***/ 823:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"eviction by sam wild","www_url":"http://www.i-love-u.ch","thema":"London","issue_month":"March","issue_year":2006,"issue_date":200603,"artist":"adnan","location":"Great Britain","email":"hadzi@i-love-u.ch","id":"contribution_186","media_type":"moving_image","position_in_section":6,"media_uri":"media/2006/March/moving_image/eviction1.mov","media_th_uri":"","still_image_count":4,"moving_image_count":6,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_186"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200603-moving-image-6-4a0637792d4be8a11ac8.js